// Sugalarm — synthesised 12-bar waveform. Same envelope idea as VoiceOrb,
// scaled up for the bottom-of-screen voice banner.

import { useEffect, useState } from "react";

interface Props {
  speaking: boolean;
  color?: string;
  width?: number;
  height?: number;
  bars?: number;
}

export function Waveform({
  speaking,
  color = "var(--accent)",
  width = 80,
  height = 32,
  bars = 12,
}: Props) {
  const [t, setT] = useState(0);

  useEffect(() => {
    if (!speaking) return;
    let raf = 0;
    const start = performance.now();
    const tick = (now: number) => {
      setT((now - start) / 1000);
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [speaking]);

  const gap = 2;
  const bw = (width - gap * (bars - 1)) / bars;
  const heights: number[] = [];
  for (let i = 0; i < bars; i++) {
    const phase = i * 0.5;
    const env = speaking
      ? 0.3 +
        0.7 *
          Math.abs(Math.sin(t * 5.2 + phase)) *
          (0.55 + 0.45 * Math.sin(t * 11.3 + phase * 1.7)) *
          (0.7 + 0.3 * Math.sin(t * 2.1 + phase * 0.4))
      : 0.14;
    heights.push(Math.max(0.08, Math.min(1, env)));
  }

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      style={{ display: "block", flexShrink: 0 }}
    >
      {heights.map((h, i) => {
        const barH = h * height;
        return (
          <rect
            key={i}
            x={i * (bw + gap)}
            y={(height - barH) / 2}
            width={bw}
            height={barH}
            rx={bw / 2}
            fill={color}
            opacity={0.55 + 0.45 * h}
            style={{ transition: "y 70ms, height 70ms, opacity 70ms" }}
          />
        );
      })}
    </svg>
  );
}
